import { render, staticRenderFns } from "./appImHelper.vue?vue&type=template&id=15e5fafc&scoped=true"
import script from "./appImHelper.vue?vue&type=script&lang=js"
export * from "./appImHelper.vue?vue&type=script&lang=js"
import style0 from "./appImHelper.vue?vue&type=style&index=0&id=15e5fafc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e5fafc",
  null
  
)

export default component.exports